import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

/* Bandeau cookies RGPD — cookies essentiels par défaut, analytiques après consentement.
   Consentement stocké en cookie (pas de localStorage — règle projet). */
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? match[1] : null;
};

const setCookie = (name, value) => {
  document.cookie = `${name}=${value}; max-age=${60 * 60 * 24 * 180}; path=/; SameSite=Lax`;
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookie("hrc_cookie_consent")) setVisible(true);
  }, []);

  const decide = (value) => {
    setCookie("hrc_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 md:bottom-6 inset-x-0 md:inset-x-auto md:left-1/2 md:-translate-x-1/2 z-[60] w-full md:max-w-[620px] bg-white border border-line rounded-t-2xl md:rounded-2xl shadow-elevated p-5 md:p-6"
      role="dialog"
      aria-label="Gestion des cookies"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-xl bg-brand-highlight flex items-center justify-center shrink-0">
          <Cookie size={20} className="text-brand-royal" aria-hidden="true" />
        </div>
        <div>
          <p className="font-heading font-semibold text-brand-deep text-[15px]">Vos données vous appartiennent</p>
          <p className="text-[13.5px] text-ink-secondary mt-1">
            On utilise des cookies essentiels au fonctionnement du site. Les cookies de mesure d'audience ne sont activés qu'avec votre accord.{" "}
            <Link to="/cookies" className="text-brand-royal underline underline-offset-2">En savoir plus</Link>
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:justify-end">
        <button type="button" onClick={() => decide("essential")} className="btn-base btn-outline-deep !py-2.5 !px-5 !text-sm" data-testid="cookie-refuse-btn">
          Essentiels uniquement
        </button>
        <button type="button" onClick={() => decide("all")} className="btn-base btn-metal !py-2.5 !px-5 !text-sm" data-testid="cookie-accept-btn">
          Tout accepter
        </button>
      </div>
    </div>
  );
};
